import { RootState } from '../reducers'

export const cantineSelector = (state: RootState, id: number) => state.cantine.items[id]
